export default "/_next/static/audios/1048b0cd2102dbcf48b9f5344c757793.mp3";